import { Loader } from 'pixi.js';
export var createResourceName = function (category, rawName) { return category + '-' + rawName; };
var mapImagePrefix = 'map-image--';
export var mapStringUtil = {
    /**
     * 'http://localhost/a/b/c.png' => 'http://localhost/a/b/'
     */
    getBaseUrl: function (url) { return url.substr(0, url.lastIndexOf('/') + 1); },
    isMap: function (name) { return name.startsWith(createResourceName('maps', '')); },
    isMapImage: function (name, mapName) { return name.startsWith(mapImagePrefix + mapName); },
    createMapImageResourceName: function (mapName, imageName) { return mapImagePrefix + mapName + '>' + imageName; },
    extractMapImageName: function (imageResourceName, mapName) { return imageResourceName.substr(mapStringUtil.createMapImageResourceName(mapName, '').length); }
};
var mapLoaderMiddleware = function (resource, next) {
    var _this = this;
    if (!mapStringUtil.isMap(resource.name)) {
        return next();
    }
    if (resource.error) {
        return next();
    }
    var url = resource.url;
    var map = resource.data;
    var nbrTilesets = map.tilesets.length;
    if (!nbrTilesets) {
        return next();
    }
    var nbrTilesetsCompleted = 0;
    var onTilesetComplete = function () {
        nbrTilesetsCompleted++;
        if (nbrTilesetsCompleted === nbrTilesets) {
            next();
        }
    };
    var baseUrl = mapStringUtil.getBaseUrl(url);
    map.tilesets.forEach(function (_a) {
        var imageName = _a.name, image = _a.image;
        var name = mapStringUtil.createMapImageResourceName(resource.name, imageName);
        if (!_this.resources[name]) {
            var loadOptions = {
                name: name,
                url: baseUrl + image,
                parentResource: resource,
                onComplete: onTilesetComplete,
            };
            _this.add(loadOptions);
        }
        else {
            onTilesetComplete();
        }
    });
};
export var createLoader = function () {
    var loader = new Loader();
    loader.use(mapLoaderMiddleware);
    return loader;
};
